export default {
  root: ({ instance, context }) => {
    const variant =
      instance?.$props?.variant || instance?.$attrs?.variant || "primary";
    const width = instance?.$props?.width || instance?.$attrs?.width || "auto";
    const size = instance?.$props?.size || instance?.$attrs?.size || "sm";

    return {
      class: [
        {
          "p-btn-root_disabled": context.disabled,
          "p-btn-root_primary": variant === "primary",
          "p-btn-root_secondary": variant === "secondary",
          "p-btn-root_tertiary": variant === "tertiary",
          "p-btn-root_link": variant === "link",
          "p-btn-root_business": variant === "business",
          "p-btn-root_upgrade": variant === "upgrade",
          "p-btn-root_size_full": width === "full",
          "p-btn-root_size_sm": size === "sm",
          "p-btn-root_size_md": size === "md",
        },
      ],
      style: {
        "--svg-fill": instance?.$attrs?.["icon-color"] || "white",
      },
    };
  },
  loadingIcon: ({ props }) => ({
    class: ["loading-spinner"],
  }),
  label: () => ({}),
};
